// extracted by mini-css-extract-plugin
export default {"service_main":"S2_Services_service_main__rv9BE","service_header_text":"S2_Services_service_header_text__+Thum","service_Desc_text":"S2_Services_service_Desc_text__fPDu2"};